import React, { useImperativeHandle, useMemo } from 'react'
import { useJoyride } from 'react-joyride'
import { useSelector } from 'react-redux'
import { darkModeSelector } from 'app-redux/selectors'

// Transitional adapter for react-joyride v3.
// Keeps the v2 prop shape (`callback`, top-level `spotlightPadding`) and the v2 ref API
// (`ref.helpers.next()`, `ref.props.run`) so existing consumers keep working unchanged.
// TODO: migrate consumers to `useJoyride` directly and remove this adapter.
const ProductTour = ({ innerRef, callback, run = false, spotlightPadding = 0, ...props }) => {
  const darkMode = useSelector(darkModeSelector)

  const options = useMemo(
    () => ({
      zIndex: 10000,
      arrowColor: darkMode ? '#1f1f1f' : 'white',
      backgroundColor: darkMode ? '#1f1f1f' : 'white',
      textColor: darkMode ? 'white' : '#1f1f1f',
      primaryColor: '#4777F3',
      showProgress: true,
      skipBeacon: true,
      spotlightPadding,
    }),
    [darkMode, spotlightPadding],
  )

  const { Tour, controls } = useJoyride({
    continuous: true,
    scrollToFirstStep: true,
    run,
    onEvent: callback,
    options,
    styles: {
      tooltipContent: {
        fontSize: 16,
        lineHeight: 1.6,
      },
    },
    ...props,
  })

  useImperativeHandle(
    innerRef,
    () => ({
      helpers: controls,
      props: { run },
    }),
    [controls, run],
  )

  return Tour
}

const Component = React.forwardRef((props, ref) => <ProductTour innerRef={ref} {...props} />)
export default React.memo(Component)
